export default "__VITE_ASSET__CsvCMz0I__"